import { Component, EventEmitter, Input, Output } from '@angular/core';

import {
  ReferralContext,
  ReferralsPortalApplication,
  ReferralsPortalApplicationStatus,
} from '@recruitee/http/types';
import { I18nService } from '@recruitee/i18n';
import { IconName } from '@recruitee/user-interface';

@Component({
  selector: 'rtr-referrals-card',
  templateUrl: './referrals-card.component.html',
  styleUrls: ['./referrals-card.component.less'],
})
export class ReferralsCardComponent {
  @Input() public application: ReferralsPortalApplication;
  @Input() public showStatus: boolean;
  @Input() public type: ReferralContext;
  @Input() public rewardsVisible: boolean;
  @Input() public statusTranslationsMap: Record<string, { status: string; icon: IconName }>;
  @Output() public referralSelect: EventEmitter<ReferralsPortalApplication> = new EventEmitter();

  public offerTooltipTranslations: Record<string, string> = {
    [ReferralsPortalApplicationStatus.InReview]: this.i18n.translate(
      'rtr.job_details.status_tooltip.in_progress',
    ),
    [ReferralsPortalApplicationStatus.ProcessComplete]: this.i18n.translate(
      'rtr.job_details.status_tooltip.completed',
    ),
    [ReferralsPortalApplicationStatus.Success]: this.i18n.translate(
      'rtr.job_details.status_tooltip.success',
    ),
  };

  public readonly ReferralStatus: typeof ReferralsPortalApplicationStatus =
    ReferralsPortalApplicationStatus;
  public readonly ReferralContext: typeof ReferralContext = ReferralContext;

  constructor(private i18n: I18nService) {}

  public selectCandidate(application: ReferralsPortalApplication): void {
    if (!this.rewardsVisible || !this.application.referralReward) return;
    this.referralSelect.emit(application);
  }
}
